import { register } from '@getgo/chameleon-typography/register';
register();
